import React, {Component, useEffect, useState} from 'react';
import axios from "axios";
import {Routes, Route, useParams, Navigate} from 'react-router-dom';
import "yet-another-react-lightbox/styles.css";
import Layout from "./Components/Layout";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {Tab, Tabs} from "react-bootstrap";
import PhoneNumberComponent from "./Components/PhoneNumberComponent";
import QuoteHeaders from "./Data/quotes.json";
import { Button, Modal, Form } from "react-bootstrap";


const ViewRecord = () => {

    const [supplierData, setSupplierData] = useState(0);
    const [redirect, setRedirect] = React.useState(false);
    const [inputValue, setInputValue] = useState('');
    const [innerRecord, setInnerRecord] = useState([]);
    const [innerContact, setInnerContact] = useState([]);
    const [innerComm, setInnerComm] = useState([]);
    const [innerFiles, setInnerFiles] = useState([]);
    const [innerSupplierData, setInnerSupplierData] = useState([]);
    const [emailSync, setEmailSync] = useState(false);
    const [peakMail, setPeakMail] = useState([]);
    const [show, setShow] = useState(false);
    const [newEmailshow, setNewEmailshow] = useState(false);
    const [popupData, setPopupData] = useState(0);
    const [contact, setContact] = useState('');
    const [subject, setSubject] = useState('');
    const [message, setMessage] = useState('');
    const [lastUpdatedBy, setLastUpdatedBy] = useState('');
    const [showFileViewer, setShowFileViewer] = useState(false);
    const [viewerFileUrl, setViewerFileUrl] = useState(null);
    const [viewerFileType, setViewerFileType] = useState(null);
    const [isLoadingFile, setIsLoadingFile] = useState(false);

    let { recordId } = useParams();
    let { dataId } = useParams();

    useEffect(() => {
        console.log(innerSupplierData)
        console.log(innerContact)

        axios.get(`get-supplier-data/${recordId}`)
            .then(response => {
                const supplier = response.data.supplier;
                const lastUpdatedBy = response.data.last_updated_by;
                const files = response.data.files;
                const unauthorized = response.data.unauthorized;
                if(unauthorized === true)
                {
                    setRedirect(unauthorized)
                }
                setSupplierData(supplier)
                setLastUpdatedBy(lastUpdatedBy)
                setInnerFiles(files)
                console.log(supplier);
                setInputValue(response.data.PeakItem);
            })

        axios.get(`get-supplier-inner-data/${dataId}`)
            .then(response => {
                const itemData = response.data.itemData;
                const contacts = response.data.contacts;
                const communications = response.data.communications;
                const supplier = response.data.supplier;
                const emailSync = response.data.emailSyncEnabled;
                const peakMail = response.data.peakMail;

                setInnerRecord(itemData)
                setInnerContact(contacts)
                setInnerComm(communications)
                setInnerSupplierData(supplier)
                setEmailSync(emailSync)
                setPeakMail(peakMail)
            })
    }, []);

    const formatDateColor = (dateString)=> {
        if(dateString === undefined) {
            return '#000';
        }
        const [year, month, day] = dateString.split('-');
        const inputDate = new Date(year, month - 1, day, 0,0, 0);

        if (!isNaN(inputDate.getTime())) {
            const formattedDate = inputDate.toLocaleDateString('en-US', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
            });
            if(new Date() > inputDate)
            {
                return '#f00'
            }
            else
            {
                return '#000';
            }
        }
    };

    const getFormattedDate = (dateString) => {
        if (dateString !== undefined && dateString.trim() !== '') {
            const [year, month, day] = dateString.split('-');
            const inputDate = new Date(year, month - 1, day, 0,0, 0);

            if (!isNaN(inputDate.getTime())) {
                const formattedDate = inputDate.toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                });
                return formattedDate;
            } else {
                return "Invalid Date";
            }
        } else {
            return "Invalid Input";
        }
    };

    const formatDateTime = (dateString) => {
        if(dateString !== undefined)
        {
            const myDate = new Date(dateString);

            return  myDate.toLocaleString('en-US', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
            });
        }
    };

    const formatEmailDateTime = (dateStr) => {
        if(dateStr !== undefined)
        {
            const dateObj = new Date(dateStr);
            const today = new Date();

            const isToday = dateObj.toDateString() === today.toDateString();
            const isCurrentYear = dateObj.getFullYear() === today.getFullYear();

            if (isToday) {
                return dateObj.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true });
            } else {
                const options = isCurrentYear ? { day: 'numeric', month: 'short' } : { day: 'numeric', month: 'short', year: 'numeric' };
                return dateObj.toLocaleDateString('en-US', options);
            }
        }
    };

    const handleInputChange = (e) => {
        setInputValue(e.target.value);
    };

    const onSaveClick = (e) => {
        console.log(inputValue)
        let dataObj = {
            peakItemNumber:  inputValue,
            Id: dataId
        }
        console.log(dataObj)
        axios.put(`update-supplier-peak`, dataObj)
            .then(response => {
                toast.success('Data saved Successfully!');
            })
    };

    const onNewEmailClick = (e) => {
        setNewEmailshow(true)
    };

    const onEmailSyncClick = (e) => {
        let dataObj = {
            recordId:  recordId,
            dataId: dataId
        }

        axios.put(`peakmail/token-generate`, dataObj)
            .then(response => {
                if(response.data != null && response.data.auth_url != null){
                    window.location.href = response.data.auth_url;
                }
            })
    };

    // Handle file viewer with modal
    const handleViewConfirmationEmail = async () => {
        if (supplierData && (supplierData.ConfirmationEmailS3Key || supplierData.ConfirmationEmailUrl)) {
            setIsLoadingFile(true);
            setShowFileViewer(true);

            try {
                // Determine file type from URL or S3 key
                const fileSource = supplierData.ConfirmationEmailS3Key || supplierData.ConfirmationEmailUrl;
                const fileExtension = fileSource.split('.').pop().toLowerCase();
                const isImage = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(fileExtension);
                const isPdf = fileExtension === 'pdf';

                if (!isImage && !isPdf) {
                    toast.error('File preview is only available for images and PDFs');
                    setShowFileViewer(false);
                    setIsLoadingFile(false);
                    return;
                }

                console.log('Calling serve-file-simple API with dataId:', recordId);

                const response = await axios.get(`serve-file-simple/${recordId}`, {
                    responseType: 'blob'
                });

                const contentType = response.headers['content-type'] || 'application/pdf';
                const blob = new Blob([response.data], { type: contentType });
                const fileUrl = window.URL.createObjectURL(blob);

                setViewerFileUrl(fileUrl);
                setViewerFileType(isImage ? 'image' : 'pdf');
                setIsLoadingFile(false);
            } catch (error) {
                console.error('Error fetching file:', error);
                toast.error('Error loading file');
                setShowFileViewer(false);
                setIsLoadingFile(false);
            }
        } else {
            toast.error('No confirmation email file available');
        }
    };

    // Handle file viewer from history record
    const handleViewConfirmationEmailFromHistory = async (record) => {
        if (record && (record.ConfirmationEmailS3Key || record.ConfirmationEmailUrl)) {
            setIsLoadingFile(true);
            setShowFileViewer(true);

            try {
                // Determine file type from URL or S3 key
                const fileSource = record.ConfirmationEmailS3Key || record.ConfirmationEmailUrl;
                const fileExtension = fileSource.split('.').pop().toLowerCase();
                const isImage = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(fileExtension);
                const isPdf = fileExtension === 'pdf';

                if (!isImage && !isPdf) {
                    toast.error('File preview is only available for images and PDFs');
                    setShowFileViewer(false);
                    setIsLoadingFile(false);
                    return;
                }

                console.log('Calling serve-file-simple API with SupplierDataId:', record.SupplierDataId);

                const response = await axios.get(`serve-file-simple/${record.SupplierDataId}`, {
                    responseType: 'blob'
                });

                const contentType = response.headers['content-type'] || 'application/pdf';
                const blob = new Blob([response.data], { type: contentType });
                const fileUrl = window.URL.createObjectURL(blob);

                setViewerFileUrl(fileUrl);
                setViewerFileType(isImage ? 'image' : 'pdf');
                setIsLoadingFile(false);
            } catch (error) {
                console.error('Error fetching file:', error);
                toast.error('Error loading file');
                setShowFileViewer(false);
                setIsLoadingFile(false);
            }
        } else {
            toast.error('No confirmation email file available for this record');
        }
    };

    // Handle closing the file viewer
    const handleCloseViewer = () => {
        // Clean up blob URL
        if (viewerFileUrl) {
            window.URL.revokeObjectURL(viewerFileUrl);
        }

        setShowFileViewer(false);
        setViewerFileUrl(null);
        setViewerFileType(null);
        setIsLoadingFile(false);
    };

    // Handle download from viewer
    const handleDownloadFromViewer = async () => {
        if (supplierData && (supplierData.ConfirmationEmailS3Key || supplierData.ConfirmationEmailUrl)) {
            try {
                const response = await axios.get(`serve-file-simple/${recordId}`, {
                    responseType: 'blob'
                });

                const blob = new Blob([response.data]);
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                
                // Get filename from S3 key or URL
                const fileSource = supplierData.ConfirmationEmailS3Key || supplierData.ConfirmationEmailUrl;
                const filename = fileSource.split('/').pop() || `confirmation_${recordId}.pdf`;
                
                link.download = filename;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
                
                toast.success('File downloaded successfully');
            } catch (error) {
                console.error('Error downloading file:', error);
                toast.error('Error downloading file');
            }
        }
    };
    

    // Get the file URL through backend endpoint - FIXED: Removed unnecessary parameters and use dataId
    const getFileUrl = () => {
        // Use dataId which corresponds to the supplier_data_id in your API
        const fileUrl = `serve-file-simple/${dataId}`;
        console.log('File URL:', fileUrl);
        return fileUrl;
    };

    // Check if file is an image based on S3 key or URL
    const isImageFile = (keyOrUrl) => {
        if (!keyOrUrl) return false;
        const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp'];
        return imageExtensions.some(ext => keyOrUrl.toLowerCase().includes(ext));
    };

    // Check if file is a PDF based on S3 key or URL
    const isPdfFile = (keyOrUrl) => {
        if (!keyOrUrl) return false;
        return keyOrUrl.toLowerCase().includes('.pdf');
    };

    // Get file extension from S3 key or URL
    const getFileExtension = (keyOrUrl) => {
        if (!keyOrUrl) return '';
        const parts = keyOrUrl.split('.');
        return parts.length > 1 ? `.${parts[parts.length - 1]}` : '';
    };

    // Check if we have a confirmation email file - FIXED: Removed unnecessary parameters
    const hasConfirmationFile = () => {
        const hasS3Key = supplierData && supplierData.ConfirmationEmailS3Key;
        const hasUrl = supplierData && supplierData.ConfirmationEmailUrl;
        console.log('File check:', {
            hasS3Key,
            hasUrl,
            s3Key: supplierData?.ConfirmationEmailS3Key,
            url: supplierData?.ConfirmationEmailUrl
        });
        return hasS3Key || hasUrl;
    };

    const getQuoteContent = (keyData) => {
        let content = [];
        for (let i = 0; i < innerRecord.length; i++) {
            let item = innerRecord[i];
            if(keyData === 'GoodThruDate') {
                content.push(<td key={i}>{getFormattedDate(item[keyData])}</td>);
            } else if(keyData === 'dateTimeCreated') {
                content.push(<td key={i}>{formatDateTime(item[keyData])}</td>);
            } else if(keyData === 'ConfirmationEmail') {
                // Check if this record has a confirmation email
                const hasFile = item.ConfirmationEmailS3Key || item.ConfirmationEmailUrl;
                content.push(
                    <td key={i}>
                        {hasFile ? (
                            <button
                                type="button"
                                className="btn btn-sm btn-primary"
                                onClick={() => handleViewConfirmationEmailFromHistory(item)}
                                style={{padding: '2px 8px', fontSize: '12px'}}
                            >
                                <i className="fa fa-eye me-1"></i>
                                View File
                            </button>
                        ) : (
                            <span>-</span>
                        )}
                    </td>
                );
            } else {
                content.push(<td key={i}>{item[keyData] || '-'}</td>);
            }
        }
        return content;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log('Contact:', contact);
        console.log('Subject:', subject);
        console.log('Message:', message);

        setContact('');
        setSubject('');
        setMessage('');

        let emailObj = {
            To:  contact,
            Subject: subject,
            Message: message
        }

        axios.put(`peakmail/send-email`, emailObj)
            .then(response => {
                handleNewEmailClose();
                toast.success('Email Sent!');
            })
            .catch(error => {
                console.error('There was an error!', error);
            });
    };

    const handleNewEmailClose = () => setNewEmailshow(false);
    const handleClose = () => setShow(false);
    const handleShow = (p) => {
        setShow(true);
        setPopupData(p)
    };

    if(redirect)
    {
        return (<Navigate to="/suppliers-data"/>)
    }
    else {
        return (
            <Layout>

                {/* Existing Message Modal */}
                <Modal show={show} onHide={handleClose}>
                    <Modal.Header>
                        <Modal.Title>Message</Modal.Title>
                        <button type="button" className="btn-close" aria-label="Close" onClick={handleClose} style={{border: "none", background: "#fff"}}>
                            <i className="ti-close"></i>
                        </button>
                    </Modal.Header>
                    <Modal.Body>
                        { popupData && (<div>
                            <p><strong>From Name:</strong> {popupData.FromName}</p>
                            <p><strong>From Email:</strong> {popupData.FromEmail}</p>
                            <p><strong>Subject:</strong> {popupData.Subject}</p>
                            <p><strong>Message</strong></p>
                            <p>{popupData.Message}</p>
                        </div>)}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* New Email Modal */}
                <Modal show={newEmailshow} onHide={handleNewEmailClose}>
                    <Modal.Header>
                        <Modal.Title>New Email</Modal.Title>
                        <button type="button" className="btn-close" aria-label="Close" onClick={handleNewEmailClose} style={{border: "none", background: "#fff"}}>
                            <i className="ti-close"></i>
                        </button>
                    </Modal.Header>
                    <Modal.Body>
                        <Form onSubmit={handleSubmit}>
                            <Form.Group className="mb-3" controlId="formContact">
                                <Form.Label>Contact</Form.Label>
                                <Form.Select
                                    className={'form-control'}
                                    value={contact}
                                    onChange={(e) => setContact(e.target.value)}
                                    required
                                >
                                    <option value="">Select a contact</option>
                                    {innerContact.map((item) => (
                                        <option key={item.ContactId} value={item.Email}>
                                            {item.Name}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="formSubject">
                                <Form.Label>Subject</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter subject"
                                    value={subject}
                                    onChange={(e) => setSubject(e.target.value)}
                                    required
                                />
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="formMessage">
                                <Form.Label>Message</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    placeholder="Enter your message"
                                    value={message}
                                    onChange={(e) => setMessage(e.target.value)}
                                    required
                                />
                            </Form.Group>

                            <Button variant="success" type="submit">
                                Send
                            </Button>
                        </Form>
                    </Modal.Body>
                </Modal>

                

                <div style={{ height: 'calc(100vh - 70px)', overflow: 'auto', padding: '20px' }}>
                    <div className="container-fluid" style={{ paddingLeft: '0px', paddingRight: '0px' }}>
                        
                        {/* Breadcrumb */}
                        <div style={{ marginBottom: '20px' }}>
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb" style={{ background: 'transparent', padding: '0', margin: '0' }}>
                                    <li className="breadcrumb-item">
                                        <a href="/suppliers-data" style={{ color: '#6b7280', textDecoration: 'none' }}>
                                            <i className="ti-arrow-left" style={{ marginRight: '5px' }}></i>
                                            Suppliers Data
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page" style={{ color: '#333', fontWeight: '500' }}>
                                        View Supplier Record
                                    </li>
                                </ol>
                            </nav>
                        </div>

                        <Tabs defaultActiveKey="current" id="uncontrolled-tab-example" className="nav-pills" style={{ marginBottom: '20px' }}>
                            <Tab eventKey="current" title="Current">
                                <div style={{ background: 'white', borderRadius: '12px', border: '1px solid #e5e7eb', padding: '24px', marginBottom: '24px' }}>
                                    <h4 style={{ fontWeight: '600', marginBottom: '20px', color: '#333' }}>Supplier Information</h4>
                                    <div className="row">
                                        <div className="col-lg-12">
                            <ul className="list-unstyled" style={{ fontSize: '14px' }}>
                                <li style={{ padding: '12px 0', borderBottom: '1px solid #f0f0f0' }}>
                                    <div className="row align-items-center">
                                        <div className="col-md-3">
                                            <span style={{ fontWeight: '500', color: '#6b7280' }}>Apex Item #</span>
                                        </div>
                                        <div className="col-md-9">
                                            <div className="d-flex align-items-center">
                                                <input type="text"
                                                       className="form-control"
                                                       style={{ maxWidth: '300px', marginRight: '10px', height: '38px' }}
                                                       id="usr"
                                                       value={inputValue}
                                                       onChange={handleInputChange}/>
                                                <button type="button"
                                                        onClick={onSaveClick}
                                                        className="btn btn-primary"
                                                        style={{ padding: '8px 20px', fontWeight: '500' }}>Save</button>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                                <li style={{ padding: '12px 0', borderBottom: '1px solid #f0f0f0' }}>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <span style={{ fontWeight: '500', color: '#6b7280' }}>Supplier Name</span>
                                        </div>
                                        <div className="col-md-9">
                                            <span style={{ color: '#333' }}>{supplierData.SupplierName}</span>
                                        </div>
                                    </div>
                                </li>
                                <li style={{ padding: '12px 0', borderBottom: '1px solid #f0f0f0' }}>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <span style={{ fontWeight: '500', color: '#6b7280' }}>Supplier Item #</span>
                                        </div>
                                        <div className="col-md-9">
                                            <span style={{ color: '#333' }}>{supplierData.SupplierItem}</span>
                                        </div>
                                    </div>
                                </li>
                                <li style={{ padding: '12px 0', borderBottom: '1px solid #f0f0f0' }}>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <span style={{ fontWeight: '500', color: '#6b7280' }}>Item Description</span>
                                        </div>
                                        <div className="col-md-9">
                                            <span style={{ color: '#333' }}>{supplierData.ItemDescription}</span>
                                        </div>
                                    </div>
                                </li>
                                <li style={{ padding: '12px 0', borderBottom: '1px solid #f0f0f0' }}>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <span style={{ fontWeight: '500', color: '#6b7280' }}>MOQ</span>
                                        </div>
                                        <div className="col-md-9">
                                            <span style={{ color: '#333' }}>{supplierData.MOQ}</span>
                                        </div>
                                    </div>
                                </li>
                                <li style={{ padding: '12px 0', borderBottom: '1px solid #f0f0f0' }}>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <span style={{ fontWeight: '500', color: '#6b7280' }}>Pack Size</span>
                                        </div>
                                        <div className="col-md-9">
                                            <span style={{ color: '#333' }}>{supplierData.PackSize}</span>
                                        </div>
                                    </div>
                                </li>
                                <li style={{ padding: '12px 0', borderBottom: '1px solid #f0f0f0' }}>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <span style={{ fontWeight: '500', color: '#6b7280' }}>U/M</span>
                                        </div>
                                        <div className="col-md-9">
                                            <span style={{ color: '#333' }}>{supplierData.UM}</span>
                                        </div>
                                    </div>
                                </li>
                                <li style={{ padding: '12px 0', borderBottom: '1px solid #f0f0f0' }}>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <span style={{ fontWeight: '500', color: '#6b7280' }}>Tier Qty 1</span>
                                        </div>
                                        <div className="col-md-9">
                                            <span style={{ color: '#333' }}>{supplierData.TierQty1}</span>
                                        </div>
                                    </div>
                                </li>
                                <li style={{ padding: '12px 0', borderBottom: '1px solid #f0f0f0' }}>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <span style={{ fontWeight: '500', color: '#6b7280' }}>$ Cost</span>
                                        </div>
                                        <div className="col-md-9">
                                            <span style={{ color: '#333' }}>{supplierData.TierQty1Cost}</span>
                                        </div>
                                    </div>
                                </li>
                                <li style={{ padding: '12px 0', borderBottom: '1px solid #f0f0f0' }}>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <span style={{ fontWeight: '500', color: '#6b7280' }}>Tier Qty 2</span>
                                        </div>
                                        <div className="col-md-9">
                                            <span style={{ color: '#333' }}>{supplierData.TierQty2}</span>
                                        </div>
                                    </div>
                                </li>
                                <li style={{ padding: '12px 0', borderBottom: '1px solid #f0f0f0' }}>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <span style={{ fontWeight: '500', color: '#6b7280' }}>$ Cost</span>
                                        </div>
                                        <div className="col-md-9">
                                            <span style={{ color: '#333' }}>{supplierData.TierQty2Cost}</span>
                                        </div>
                                    </div>
                                </li>
                                <li style={{ padding: '12px 0', borderBottom: '1px solid #f0f0f0' }}>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <span style={{ fontWeight: '500', color: '#6b7280' }}>Tier Qty 3</span>
                                        </div>
                                        <div className="col-md-9">
                                            <span style={{ color: '#333' }}>{supplierData.TierQty3}</span>
                                        </div>
                                    </div>
                                </li>
                                <li style={{ padding: '12px 0', borderBottom: '1px solid #f0f0f0' }}>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <span style={{ fontWeight: '500', color: '#6b7280' }}>$ Cost</span>
                                        </div>
                                        <div className="col-md-9">
                                            <span style={{ color: '#333' }}>{supplierData.TierQty3Cost}</span>
                                        </div>
                                    </div>
                                </li>
                                <li style={{ padding: '12px 0', borderBottom: '1px solid #f0f0f0' }}>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <span style={{ fontWeight: '500', color: '#6b7280' }}>Lead Time (days)</span>
                                        </div>
                                        <div className="col-md-9">
                                            <span style={{ color: '#333' }}>{supplierData.LeadTime}</span>
                                        </div>
                                    </div>
                                </li>
                                <li style={{ padding: '12px 0', borderBottom: '1px solid #f0f0f0' }}>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <span style={{ fontWeight: '500', color: '#6b7280' }}>Payment Terms</span>
                                        </div>
                                        <div className="col-md-9">
                                            <span style={{ color: '#333' }}>{supplierData.PaymentTerms}</span>
                                        </div>
                                    </div>
                                </li>
                                <li style={{ padding: '12px 0', borderBottom: '1px solid #f0f0f0' }}>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <span style={{ fontWeight: '500', color: '#6b7280' }}>$ Credit Line</span>
                                        </div>
                                        <div className="col-md-9">
                                            <span style={{ color: '#333' }}>{supplierData.CreditLine}</span>
                                        </div>
                                    </div>
                                </li>
                                <li style={{ padding: '12px 0', borderBottom: '1px solid #f0f0f0' }}>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <span style={{ fontWeight: '500', color: '#6b7280' }}>Item Category</span>
                                        </div>
                                        <div className="col-md-9">
                                            <span style={{ color: '#333' }}>{supplierData.ItemCategory}</span>
                                        </div>
                                    </div>
                                </li>
                                <li style={{ padding: '12px 0', borderBottom: '1px solid #f0f0f0' }}>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <span style={{ fontWeight: '500', color: '#6b7280' }}>Good Thru Date</span>
                                        </div>
                                        <div className="col-md-9">
                                            <span style={{ color: formatDateColor(supplierData.GoodThruDate) }}>
                                                {getFormattedDate(supplierData.GoodThruDate)}
                                            </span>
                                        </div>
                                    </div>
                                </li>
                                <li style={{ padding: '12px 0', borderBottom: '1px solid #f0f0f0' }}>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <span style={{ fontWeight: '500', color: '#6b7280' }}>Shipment Packaging</span>
                                        </div>
                                        <div className="col-md-9">
                                            <span style={{ color: '#333' }}>{supplierData.ShipmentPackaging}</span>
                                        </div>
                                    </div>
                                </li>
                                <li style={{ padding: '12px 0', borderBottom: '1px solid #f0f0f0' }}>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <span style={{ fontWeight: '500', color: '#6b7280' }}>Shipment Packaging Other</span>
                                        </div>
                                        <div className="col-md-9">
                                            <span style={{ color: '#333' }}>{supplierData.ShipmentPackagingOther}</span>
                                        </div>
                                    </div>
                                </li>
                                <li style={{ padding: '12px 0', borderBottom: '1px solid #f0f0f0' }}>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <span style={{ fontWeight: '500', color: '#6b7280' }}>FOB Origin</span>
                                        </div>
                                        <div className="col-md-9">
                                            <span style={{ color: '#333' }}>{supplierData.FOBOrigin}</span>
                                        </div>
                                    </div>
                                </li>
                                <li style={{ padding: '12px 0', borderBottom: '1px solid #f0f0f0' }}>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <span style={{ fontWeight: '500', color: '#6b7280' }}>FOB Destination</span>
                                        </div>
                                        <div className="col-md-9">
                                            <span style={{ color: '#333' }}>{supplierData.FOBDestination}</span>
                                        </div>
                                    </div>
                                </li>
                                <li style={{ padding: '12px 0', borderBottom: '1px solid #f0f0f0' }}>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <span style={{ fontWeight: '500', color: '#6b7280' }}>Main Contact</span>
                                        </div>
                                        <div className="col-md-9">
                                            <span style={{ color: '#333' }}>{supplierData.MainContact}</span>
                                        </div>
                                    </div>
                                </li>
                                <li style={{ padding: '12px 0', borderBottom: '1px solid #f0f0f0' }}>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <span style={{ fontWeight: '500', color: '#6b7280' }}>Cell Ph #</span>
                                        </div>
                                        <div className="col-md-9">
                                            <span style={{ color: '#333' }}>{supplierData.CellPh}</span>
                                        </div>
                                    </div>
                                </li>
                                <li style={{ padding: '12px 0', borderBottom: '1px solid #f0f0f0' }}>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <span style={{ fontWeight: '500', color: '#6b7280' }}>Office PH #</span>
                                        </div>
                                        <div className="col-md-9">
                                            <span style={{ color: '#333' }}>{supplierData.OfficePh}</span>
                                        </div>
                                    </div>
                                </li>
                                <li style={{ padding: '12px 0', borderBottom: '1px solid #f0f0f0' }}>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <span style={{ fontWeight: '500', color: '#6b7280' }}>Shipping Address</span>
                                        </div>
                                        <div className="col-md-9">
                                            <span style={{ color: '#333' }}>{supplierData.ShippingAddress}</span>
                                        </div>
                                    </div>
                                </li>
                                <li style={{ padding: '12px 0', borderBottom: '1px solid #f0f0f0' }}>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <span style={{ fontWeight: '500', color: '#6b7280' }}>Created</span>
                                        </div>
                                        <div className="col-md-9">
                                            <span style={{ color: '#333' }}>{formatDateTime(supplierData.dateTimeCreated)}</span>
                                        </div>
                                    </div>
                                </li>
                                {hasConfirmationFile() ? (
                                    <li style={{ padding: '12px 0', borderBottom: '1px solid #f0f0f0' }}>
                                        <div className="row">
                                            <div className="col-md-3">
                                                <span style={{ fontWeight: '500', color: '#6b7280' }}>Confirmation Email</span>
                                            </div>
                                            <div className="col-md-9">
                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-primary"
                                                    onClick={handleViewConfirmationEmail}
                                                    style={{ padding: '4px 12px' }}
                                                >
                                                    <i className="fa fa-eye me-1"></i>
                                                    View File
                                                </button>
                                            </div>
                                        </div>
                                    </li>
                                ) : null}

                                <li style={{ padding: '12px 0' }}>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <span style={{ fontWeight: '500', color: '#6b7280' }}>Created By</span>
                                        </div>
                                        <div className="col-md-9">
                                            <span style={{ color: '#333' }}>{lastUpdatedBy}</span>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </Tab>
            <Tab eventKey="history" title="History">
                <div style={{ background: 'white', borderRadius: '12px', border: '1px solid #e5e7eb', padding: '24px', marginBottom: '24px' }}>
                    <h4 style={{ fontWeight: '600', marginBottom: '20px', color: '#333' }}>Quote History</h4>
                    <div className="table-responsive">
                        <table className="table table-hover">
                            <tbody>
                                {innerRecord[0] && QuoteHeaders.map((quote, quoteIndex) => (
                                    <tr key={quoteIndex}>
                                        <td style={{ fontWeight: '500', color: '#6b7280', padding: '12px', minWidth: '150px' }}>{quote.header}</td>
                                        {getQuoteContent(quote.key)}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </Tab>
            <Tab eventKey="info" title="Info">
                <div style={{ background: 'white', borderRadius: '12px', border: '1px solid #e5e7eb', padding: '24px', marginBottom: '24px' }}>
                    <h4 style={{ fontWeight: '600', marginBottom: '20px', color: '#333' }}>Additional Information</h4>
                    <div className="row">
                        {(innerSupplierData && innerContact[0]) ?
                            <React.Fragment>
                                <div className="col-lg-6">
                                    <ul className="list-unstyled" style={{ fontSize: '14px' }}>
                                        <li style={{ padding: '10px 0', borderBottom: '1px solid #f0f0f0' }}>
                                            <div className="d-flex justify-content-between">
                                                <span style={{ fontWeight: '500', color: '#6b7280' }}>Payment Terms</span>
                                                <span style={{ color: '#333' }}>{innerSupplierData['PaymentTerms']}</span>
                                            </div>
                                        </li>
                                        <li style={{ padding: '10px 0', borderBottom: '1px solid #f0f0f0' }}>
                                            <div className="d-flex justify-content-between">
                                                <span style={{ fontWeight: '500', color: '#6b7280' }}>$ Credit Line</span>
                                                <span style={{ color: '#333' }}>{innerSupplierData['CreditLine']}</span>
                                            </div>
                                        </li>
                                        <li style={{ padding: '10px 0', borderBottom: '1px solid #f0f0f0' }}>
                                            <div className="d-flex justify-content-between">
                                                <span style={{ fontWeight: '500', color: '#6b7280' }}>Shipping Address</span>
                                                <span style={{ color: '#333' }}>{innerSupplierData['ShippingAddress']}</span>
                                            </div>
                                        </li>
                                        <li style={{ padding: '10px 0' }}>
                                            <div className="d-flex justify-content-between">
                                                <span style={{ fontWeight: '500', color: '#6b7280' }}>FOB Origin</span>
                                                <span style={{ color: '#333' }}>{innerSupplierData['fobOrigin']}</span>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <div className="col-lg-6">
                                    <ul className="list-unstyled" style={{ fontSize: '14px' }}>
                                        <li style={{ padding: '10px 0', borderBottom: '1px solid #f0f0f0' }}>
                                            <div className="d-flex justify-content-between">
                                                <span style={{ fontWeight: '500', color: '#6b7280' }}>Main Contact</span>
                                                <span style={{ color: '#333' }}>{innerContact[0]['Name']}</span>
                                            </div>
                                        </li>
                                        <li style={{ padding: '10px 0', borderBottom: '1px solid #f0f0f0' }}>
                                            <div className="d-flex justify-content-between">
                                                <span style={{ fontWeight: '500', color: '#6b7280' }}>Cell Ph #</span>
                                                <span style={{ color: '#333' }}>{innerContact[0]['CellPhone']}</span>
                                            </div>
                                        </li>
                                        <li style={{ padding: '10px 0', borderBottom: '1px solid #f0f0f0' }}>
                                            <div className="d-flex justify-content-between">
                                                <span style={{ fontWeight: '500', color: '#6b7280' }}>Office PH #</span>
                                                <span style={{ color: '#333' }}>{innerContact[0]['OfficePhone']}</span>
                                            </div>
                                        </li>
                                        <li style={{ padding: '10px 0' }}>
                                            <div className="d-flex justify-content-between">
                                                <span style={{ fontWeight: '500', color: '#6b7280' }}>FOB Destination</span>
                                                <span style={{ color: '#333' }}>{innerSupplierData['fobDest']}</span>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </React.Fragment> : ''
                        }
                    </div>
                </div>
            </Tab>
            <Tab eventKey="contact" title="Contact">
                <div style={{ background: 'white', borderRadius: '12px', border: '1px solid #e5e7eb', padding: '24px', marginBottom: '24px' }}>
                    <h4 style={{ fontWeight: '600', marginBottom: '20px', color: '#333' }}>Contact Information</h4>
                    <div className="table-responsive">
                        <table className="table table-hover">
                            <thead style={{ backgroundColor: '#f8f9fa' }}>
                                <tr>
                                    <th style={{ fontWeight: '600', padding: '12px 16px', border: 'none' }}>Name</th>
                                    <th style={{ fontWeight: '600', padding: '12px 16px', border: 'none' }}>Email</th>
                                    <th style={{ fontWeight: '600', padding: '12px 16px', border: 'none' }}>Cell Phone</th>
                                    <th style={{ fontWeight: '600', padding: '12px 16px', border: 'none' }}>Office Phone</th>
                                    <th style={{ fontWeight: '600', padding: '12px 16px', border: 'none' }}>Created</th>
                                </tr>
                            </thead>
                            <tbody>
                                {innerContact[0] && innerContact.map((p, index) => (
                                    <tr key={index}>
                                        <td style={{ padding: '12px 16px', border: 'none' }}>{p.Name}</td>
                                        <td style={{ padding: '12px 16px', border: 'none' }}>{p.Email}</td>
                                        <td style={{ padding: '12px 16px', border: 'none' }}>
                                            <PhoneNumberComponent phoneNumber={p.CellPhone}/>
                                        </td>
                                        <td style={{ padding: '12px 16px', border: 'none' }}>
                                            <PhoneNumberComponent phoneNumber={p.OfficePhone}/>
                                        </td>
                                        <td style={{ padding: '12px 16px', border: 'none' }}>{formatDateTime(p.DateTimeCreated)}</td>
                                    </tr>
                                ))}

                                {innerContact.length === 0 && (
                                    <tr>
                                        <td colSpan="5" style={{ padding: '32px', textAlign: 'center', color: '#6b7280' }}>
                                            <i className="ti-user" style={{ fontSize: '48px', color: '#6c757d' }}></i>
                                            <p className="mt-3 mb-0">No Contacts</p>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </Tab>
            <Tab eventKey="communication" title="Communication">
                <div style={{ background: 'white', borderRadius: '12px', border: '1px solid #e5e7eb', padding: '24px', marginBottom: '24px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                        <h4 style={{ fontWeight: '600', margin: 0, color: '#333' }}>Email Communications</h4>
                        <div>
                            {emailSync &&
                                <button type="button" onClick={onEmailSyncClick}
                                        className="btn btn-primary"
                                        style={{ marginRight: '10px', padding: '8px 16px', fontWeight: '500' }}>
                                    <i className="ti-reload" style={{ marginRight: '8px' }}></i>
                                    Email Sync
                                </button>
                            }
                            <button type="button" onClick={onNewEmailClick}
                                    className="btn btn-success"
                                    style={{ padding: '8px 16px', fontWeight: '500' }}>
                                <i className="ti-email" style={{ marginRight: '8px' }}></i>
                                New Email
                            </button>
                        </div>
                    </div>
                    <div className="table-responsive">
                        <table className="table table-hover">
                            <thead style={{ backgroundColor: '#f8f9fa' }}>
                                <tr>
                                    <th style={{ fontWeight: '600', padding: '12px 16px', border: 'none', width: '250px' }}>Name</th>
                                    <th style={{ fontWeight: '600', padding: '12px 16px', border: 'none' }}>Message</th>
                                    <th style={{ fontWeight: '600', padding: '12px 16px', border: 'none', width: '110px' }}>Created</th>
                                </tr>
                            </thead>
                            <tbody>
                                {peakMail[0] && peakMail.map((p, index) => (
                                    <tr key={index} style={{ cursor: 'pointer' }} onClick={() => handleShow(p)}>
                                        <td style={{ padding: '12px 16px', border: 'none' }}>{p.FromName}</td>
                                        <td style={{ padding: '12px 16px', border: 'none' }}>{p.MessageSnippet}</td>
                                        <td style={{ padding: '12px 16px', border: 'none' }}>{formatEmailDateTime(p.DatetimeCreated)}</td>
                                    </tr>
                                ))}
                                {peakMail.length === 0 && (
                                    <tr>
                                        <td colSpan="3" style={{ padding: '32px', textAlign: 'center', color: '#6b7280' }}>
                                            <i className="ti-email" style={{ fontSize: '48px', color: '#6c757d' }}></i>
                                            <p className="mt-3 mb-0">No Communications</p>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </Tab>
            <Tab eventKey="system-notifications" title="System Notifications">
                <div style={{ background: 'white', borderRadius: '12px', border: '1px solid #e5e7eb', padding: '24px', marginBottom: '24px' }}>
                    <h4 style={{ fontWeight: '600', marginBottom: '20px', color: '#333' }}>System Notifications</h4>
                    <div className="table-responsive">
                        <table className="table table-hover">
                            <thead style={{ backgroundColor: '#f8f9fa' }}>
                                <tr>
                                    <th style={{ fontWeight: '600', padding: '12px 16px', border: 'none' }}>Message</th>
                                    <th style={{ fontWeight: '600', padding: '12px 16px', border: 'none' }}>Created</th>
                                </tr>
                            </thead>
                            <tbody>

                                {innerComm.map((p, index) => (
                                    <tr key={index}>
                                        <td style={{ padding: '12px 16px', border: 'none' }}>
                                            {p.Type === 10 ?
                                                "This is a friendly reminder that it is time to update pricing on this item." : 
                                                p.Type === 5 ?
                                                "This is a second friendly reminder that it is time to update pricing on this item." :
                                                "This is your final friendly reminder that it is time to update pricing on this item otherwise it will automatically renew at the current price per our Terms and Conditions, which states: 'All quoted prices auto-renew for the same quoted period, unless revised or deleted from data.'"}
                                        </td>
                                        <td style={{ padding: '12px 16px', border: 'none' }}>{formatDateTime(p.CreatedDateTime)}</td>
                                    </tr>
                                ))}

                                {innerComm.length === 0 && (
                                    <tr>
                                        <td colSpan="2" style={{ padding: '32px', textAlign: 'center', color: '#6b7280' }}>
                                            <i className="ti-bell" style={{ fontSize: '48px', color: '#6c757d' }}></i>
                                            <p className="mt-3 mb-0">No System Notifications</p>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </Tab>
            <Tab eventKey="filemanager" title="Files">
                <div style={{ background: 'white', borderRadius: '12px', border: '1px solid #e5e7eb', padding: '24px', marginBottom: '24px' }}>
                    <h4 style={{ fontWeight: '600', marginBottom: '20px', color: '#333' }}>Attached Files</h4>
                    <div className="table-responsive">
                        <table className="table table-hover">
                            <thead style={{ backgroundColor: '#f8f9fa' }}>
                                <tr>
                                    <th style={{ fontWeight: '600', padding: '12px 16px', border: 'none' }}>Filename</th>
                                    <th style={{ fontWeight: '600', padding: '12px 16px', border: 'none' }}>Type</th>
                                </tr>
                            </thead>
                            <tbody>

                                {innerFiles.map((p, index) => (
                                    <tr key={index}>
                                        <td style={{ padding: '12px 16px', border: 'none' }}>{p.actualname}</td>
                                        <td style={{ padding: '12px 16px', border: 'none' }}>
                                            {p.type === 1 ? 'Specs' : 'SIDI'}
                                        </td>
                                    </tr>
                                ))}

                                {innerFiles.length === 0 && (
                                    <tr>
                                        <td colSpan="2" style={{ padding: '32px', textAlign: 'center', color: '#6b7280' }}>
                                            <i className="ti-files" style={{ fontSize: '48px', color: '#6c757d' }}></i>
                                            <p className="mt-3 mb-0">No Files</p>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </Tab>
        </Tabs>
    </div>
</div>

                {/* File Viewer Modal */}
                <Modal 
                    show={showFileViewer} 
                    onHide={handleCloseViewer} 
                    size="xl"
                    centered
                >
                    <Modal.Header style={{backgroundColor: "#f8f9fa"}}>
                        <Modal.Title>
                            {supplierData?.SupplierName ? `Confirmation Email - ${supplierData.SupplierName}` : 'File Viewer'}
                        </Modal.Title>
                        <button type="button" className="btn-close" aria-label="Close" onClick={handleCloseViewer} style={{border: "none", background: "#fff"}}>
                            <i className="ti-close"></i>
                        </button>
                    </Modal.Header>
                    <Modal.Body style={{backgroundColor: "#f8f9fa", padding: "0"}}>
                        {isLoadingFile ? (
                            <div style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "500px"
                            }}>
                                <div className="spinner-border text-primary" role="status" style={{width: "3rem", height: "3rem"}}>
                                    <span className="sr-only">Loading...</span>
                                </div>
                            </div>
                        ) : (
                            <div style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                minHeight: "500px",
                                maxHeight: "80vh",
                                overflow: "auto",
                                backgroundColor: "#e9ecef"
                            }}>
                                {viewerFileType === 'image' && viewerFileUrl && (
                                    <img 
                                        src={viewerFileUrl} 
                                        alt="Confirmation Email"
                                        style={{
                                            maxWidth: "100%",
                                            maxHeight: "80vh",
                                            objectFit: "contain"
                                        }}
                                    />
                                )}
                                {viewerFileType === 'pdf' && viewerFileUrl && (
                                    <div style={{ width: "100%", height: "80vh", position: "relative" }}>
                                        <iframe
                                            src={`${viewerFileUrl}#toolbar=1&navpanes=0&scrollbar=1`}
                                            title="Confirmation Email PDF"
                                            style={{
                                                width: "100%",
                                                height: "100%",
                                                border: "none"
                                            }}
                                        />
                                        <div style={{
                                            position: "absolute",
                                            bottom: "10px",
                                            left: "50%",
                                            transform: "translateX(-50%)",
                                            backgroundColor: "rgba(0,0,0,0.7)",
                                            color: "white",
                                            padding: "10px 20px",
                                            borderRadius: "5px",
                                            fontSize: "12px"
                                        }}>
                                            If PDF doesn't display, click Download to view it locally
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                    </Modal.Body>
                    <Modal.Footer style={{backgroundColor: "#f8f9fa"}}>
                        <Button 
                            variant="success" 
                            onClick={handleDownloadFromViewer}
                            disabled={isLoadingFile}
                        >
                            <i className="ti-download"></i> Download
                        </Button>
                        <Button 
                            variant="secondary" 
                            onClick={handleCloseViewer}
                        >
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            </Layout>
        );
    }

}

export default ViewRecord;